import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiSearch, FiFilter, FiChevronDown } from "react-icons/fi";
import PharmacyTable from './PharmacyTable';
import PurchaseTable from './PurchaseTable';
import SalesTable from './SalesTable';
import TimelineTable from './TimelineTable';
import SubstituteTable from './SubstituteTable';
import BranchTable from './BranchTable';
import DistributorTable from './DistributorTable';
import AddSettings from "./AddSettings"; 
import { Modal } from "react-bootstrap"; 
import { Offcanvas } from "react-bootstrap";
import AddBatchForm from "./AddBatchForm";
import SideFilters from "../pharmacy/Utility/SideFilters";
import { SideSort } from  "../pharmacy/Utility/SideSort";



function PharmacyStock() {
 
  const [showAddPharmacy, setShowAddPharmacy] = useState(false);

  const handleAddNewItem = () => {
    setShowAddPharmacy(true); // 👈 open offcanvas instead of navigating
  };

  const handleClose = () => {
    setShowAddPharmacy(false);
  };


   const [showSettingsModal, setShowSettingsModal] = useState(false);

  const handleSettings = () => {
    setShowSettingsModal(true); // open modal instead of navigation
  };
  const handleCloseSettings = () => {
  setShowSettingsModal(false);
};

  

  const [filterValue, setFilterValue] = useState("FILTER BY");
  const [sortValue, setSortValue] = useState("SORT BY");
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("batches");
  const [activeFilterTab, setActiveFilterTab] = useState("distributor");
  const [searchTerm, setSearchTerm] = useState("");
  const [hasUnsavedDrafts, setHasUnsavedDrafts] = useState(true);
  const [open, setOpen] = useState(false);

  const [currentStep, setCurrentStep] = useState(0);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedPaymentMode, setSelectedPaymentMode] = useState("");
  const [paymentDetails, setPaymentDetails] = useState({});
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  const handleAddDistributor = () => {
    setOpen(true);
  };
  

  const openPaymentModal = () => {
    setCurrentStep(1);
    setShowPaymentModal(true);
  };

  const closePaymentModal = () => {
    setShowPaymentModal(false);
    setCurrentStep(0);
    setSelectedPaymentMode("");
    setPaymentDetails({});
  };

  const handleStep1Next = (mode) => {
    setSelectedPaymentMode(mode);
    setCurrentStep(2);
  };

  const handleStep2Next = (details) => {
    setPaymentDetails(details);
    setCurrentStep(3);
  };

  const handleStep2Back = () => {
    setCurrentStep(1);
  };

  const handleStep3Back = () => {
    setCurrentStep(2);
  };
  

  const handleStep3Save = (finalData) => {
    console.log("Final Payment Data:", {
      distributor: distributors.find((d) => d.id === selectedDistributor),
      paymentMode: selectedPaymentMode,
      ...finalData,
    });

    setToastMessage("Payment transaction saved successfully!");
    setShowToast(true);

    closePaymentModal();
  };

  const tabs = [
    { id: "purchase", label: "BATCHES" },
    { id: "returns", label: "PURCHASES" },
    { id: "payments", label: "SALES" },
    // keep other tabs mapping as you need in your app
  ];

  const handlePurchaseOrder = () => navigate("/PurchaseOrder");
  const handleAddBilling = () => navigate("/AddBilling");
  const handlePharmacyPurchasereturn = () =>
    navigate("/PharmacyPurchasereturn");

  // --- distributors data (extended with UI fields; missing values are null) ---
  const distributors = [
    {
      id: 1,
      code: "DO",
      name: "Doplus Dt Tab.",
      company: "Orgyn Laboratories Pvt Ltd",
      price: 73.13,
      due: "₹0.00",
      amount: "73.13",
      status: "In Stock",
      lastTxn: "04/27",
      contact: "9966288868",
      gst: null,
      drugLic: null,
      exp: "04/27",
      stockQty: "2 packs",
      pack: "Pack of 10",
      inStock: true,
      shortDesc: "Pack of 10",
    },
    {
      id: 2,
      code: "DO",
      name: "Dolo 650",
      company: "Delta Labs",
      price: 456.0,
      due: "₹0.00",
      amount: "456.00",
      status: "In Stock",
      lastTxn: "12/27",
      contact: null,
      gst: null,
      drugLic: null,
      exp: "12/27",
      stockQty: "110 packs",
      pack: "Pack of 1",
      inStock: true,
      shortDesc: "110 packs, 0 units",
    },
    {
      id: 3,
      code: "A",
      name: "Amoxicllin",
      company: "MedPlus",
      price: 202.33,
      due: "₹0.00",
      amount: "202.33",
      status: "In Stock",
      lastTxn: "01/26",
      contact: null,
      gst: null,
      drugLic: null,
      exp: "01/26",
      stockQty: "39 packs",
      pack: "Pack of 15",
      inStock: true,
      shortDesc: "39 packs",
    },
    {
      id: 4,
      code: "DL",
      name: "Dloratin Tab",
      company: "Cipla Ltd",
      price: 202.33,
      due: "₹0.00",
      amount: "202.33",
      status: "In Stock",
      lastTxn: "01/26",
      contact: null,
      gst: null,
      drugLic: null,
      exp: "01/26",
      stockQty: "1 packs",
      pack: "Pack of 15",
      inStock: true,
      shortDesc: "1 packs",
    },
    // more items with nulls for missing values:
    {
      id: 5,
      code: "XX",
      name: "Placeholder Item",
      company: null,
      price: null,
      due: null,
      amount: null,
      status: "Out of Stock",
      lastTxn: null,
      contact: null,
      gst: null,
      drugLic: null,
      exp: null,
      stockQty: null,
      pack: null,
      inStock: false,
      shortDesc: null,
    },
  ];

  const [selectedDistributor, setSelectedDistributor] = useState(
    distributors[1]?.id || distributors[0]?.id
  );

  // Helper to format price (if number else keep null)
  const formatPrice = (price) =>
    price === null || price === undefined ? null : `₹${price.toLocaleString()}`;

  // ---------- styles + layout ----------
  return (
    <>
      <style>
        {`
        /* layout */
        .pharmacy-container {
          display: flex;
          height: calc(100vh - 80px);
          background: #f5f5f5;
          gap: 0;
          font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial;
        }

        /* left sidebar */
        .sidebar-container {
          width: 360px;
          min-width: 300px;
          background: white;
          color: #000;
          display: flex;
          flex-direction: column;
          box-shadow: 2px 0 10px rgba(0,0,0,0.06);
        }

        .sidebar-header {
          padding: 18px 18px;
         
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .sidebar-title { font-size: 16px; font-weight: 700; margin: 0; color:#222; }
        .sidebar-subtitle { font-size: 12px; color:#777; margin-top:4px; }

        .search-section {
          padding: 12px 14px;
          border-bottom: 1px solid #f0f0f0;
          background: #fff;
        }

        .search-row {
          display:flex; gap:8px; align-items:center;
        }
          .search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
}
  .search-icon {
  position: absolute;
  right: 12px;
  color: #999;
  font-size: 18px;
  pointer-events: none;
}

        .search-input {
          flex:1;
          padding: 10px 40px 10px 12px; /* space for icon on right */
          border-radius: 8px;
          border: 1px solid #e6e6e6;
          font-size: 14px;
          background: #fff;
        }
        .filter-select {
          width: 110px;
          padding: 9px 10px;
          border-radius: 8px;
          border: 1px solid #e6e6e6;
          background:#fff;
          font-size:13px;
        }

              .distributor-list {
              overflow-y: auto;
              padding: 10px;
            }

            .distributor-item {
              display: flex;
              padding: 12px;
              border-radius: 8px;
              border-left: 4px solid transparent;
              background: #fff;
              margin-bottom: 12px;
              box-shadow: 0 1px 3px rgba(0,0,0,0.05);
              transition: all 0.2s ease;
              cursor: pointer;
            }

            .distributor-item:hover {
              background: #fafafa;
              transform: translateY(-1px);
            }

            .distributor-item.selected {
              border-left: 3px solid #7ee6a0ff;
              background: #f3fdf5;
              box-shadow: 0 4px 12px rgba(58, 181, 74, 0.15);
            }

            .avatar {
              width: 48px;
              height: 48px;
              border-radius: 6px;
              background: #f1f6f2;
              color: #2e6b4a;
              font-weight: 700;
              font-size: 16px;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-right: 14px;
            }

            .dist-info {
              flex: 1;
              display: flex;
              flex-direction: column;
            }

            .top-row {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 6px;
            }

            .dist-name {
              font-size: 14px;
              font-weight: 600;
              color: #222;
            }

            .dist-price {
              font-size: 14px;
              font-weight: 500;
              color: #111;
            }

            .dist-company {
              font-size: 12px;
              color: #777;
              margin-bottom: 6px;
            }

            .bottom-row {
              display: flex;
              justify-content: space-between;
              align-items: center;
              font-size: 12px;
              color: #555;
            }

            .dist-stock {
              display: flex;
              align-items: center;
              gap: 8px;
            }

            .stock-badge {
              background-color: #e6f4ec;
              color: #2e6b4a;
              padding: 2px 6px;
              border-radius: 4px;
              font-size: 11px;
              font-weight: 600;
            }

            .pack-info {
              color: #555;
            }

            .dist-extra {
              text-align: right;
            }

            .exp {
              color: #333;
            }

            .qty {
              font-size: 12px;
              color: #666;
            }

        .in-stock { background: #e6f6ec; color: #2e6b4a; border: 1px solid rgba(46,107,74,0.08);}
        .out-stock { background:#fff2f2; color:#b12b2b; border: 1px solid rgba(177,43,43,0.08); }

        .add-new-btn {
       
          padding: 8px;
          margin: 12px;
          background:#2e6b4a;
          color:white;
          border-radius:8px;
          border:none;
          font-weight:500;
          cursor:pointer;
        }

        /* right main area */
        .main-content {
          flex:1; background:#fff; overflow-y:auto; position:relative;
        }

        .content-header {
          padding: 18px 22px;
         
          background:#fff;
        }
        .distributor-info {
          display:flex; justify-content:space-between; align-items:flex-start; gap:20px; flex-wrap:wrap;
        }
        .distributor-header {
          display:flex; gap:16px; align-items:flex-start;
        }
        .distributor-header-avatar {
          width:86px; height:86px; border-radius:10px; display:flex; align-items:center; justify-content:center;
          font-weight:700; font-size:22px; color:#2e6b4a; background:#f1f6f2; border:1px solid rgba(46,107,74,0.06);
        }
        .distributor-details h2 { margin:0 0 8px 0; font-size:20px; color:#222; }
        .distributor-details p { margin:0; color:#666; font-size:13px; line-height:1.4; }

        .panel-actions { display:flex; gap:10px; align-items:center; }

        .action-btn {
          background:#3c4854; color:white; fontSize:12px; padding:10px 14px; border-radius:8px; border:none; cursor:pointer; font-weight:400;
        }
        .action-btn.secondary { background: transparent; color:#333; border:1px solid #e6e6e6; }

        /* stats strip (like header details) */
        .stats-strip {
          padding: 12px 22px;
          display:grid;
          grid-template-columns: repeat(6, 1fr);
          gap: 12px;
          border-bottom:1px solid #f6f6f6;
          font-size:13px;
          margin-top:-15px;
          align-items:center;
          color:#444;
        }
        .stats-strip .label { font-size:11px; text-transform:uppercase; color:#999; font-weight:600; }
        .stats-strip .value { font-weight:700; color:#222; }
        .distributor-header-avatar {
  width: 100px;
  height: 100px;
  border-radius: 8px; /* Optional: slight rounding */
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5; /* fallback */
}

.tablet-avatar-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

        /* tabs area */
        .tabs-container {
          margin: 18px 22px 22px 22px;
          background: #fff;
          border-radius:8px;
          overflow:hidden;
          box-shadow: 0 1px 6px rgba(0,0,0,0.03);
        }
        .tabs-header {
          display:flex; border-bottom:1px solid #eee; background:#fff;
        }
        .tab-button {
          padding: 14px 18px;
          background:none; border:none; cursor:pointer; font-weight:600; color:#666; font-size:13px;
        }
        .tab-button.active {
          color:#2e6b4a; border-bottom:3px solid #7ee6a0ff; background: linear-gradient(180deg, rgba(78,155,108,0.06), transparent);
        }
        .tab-content { padding: 12px; min-height: 260px; }
        
        @media (max-width: 900px) {
          .sidebar-container { width: 100%; min-width: auto; max-height: 40vh; }
          .pharmacy-container { flex-direction: column; height: auto; }
        }
      `}
      </style>

      <div className="pharmacy-container">

        {/* Main Content (right) */}
        <div className="main-content">
          {selectedDistributor ? (
            <>
             <div className="content-header bg-white p-6 rounded-xl shadow-sm border border-gray-100">
  {/* Top Row: Image + Info + Settings */}
  <div className="flex items-start justify-between">
    {/* Left Section */}
    <div className="flex items-start gap-6">
      {/*  Bigger Image */}
      <div className="flex-shrink-0 w-36 h-36 rounded-xl overflow-hidden bg-gray-50 flex items-center justify-center border border-gray-100 shadow-sm">
        <img
          src="https://i.pinimg.com/736x/d5/26/b0/d526b06fb3760ce3f96d4fa22bb12581.jpg"
          alt="Tablet"
          className="w-full h-full object-contain"
        />
      </div>

      {/* Product Info */}
      <div className="flex flex-col justify-center">
        <h2 className="text-2xl font-semibold text-gray-900 mb-1">
          {distributors.find((d) => d.id === selectedDistributor)?.name || "—"}
        </h2>

        <p className="text-sm text-gray-500 mb-2">
          {distributors.find((d) => d.id === selectedDistributor)?.company || "—"}
        </p>

        {/* Field Strip Directly Under Product Info */}
        <div className="mt-3 grid grid-cols-6 gap-4 text-sm text-gray-700">
          <div>
            <p className="text-gray-500 uppercase text-xs font-medium">PACK</p>
            <p className="font-semibold">
              {distributors.find((d) => d.id === selectedDistributor)?.pack || "-"}
            </p>
          </div>
          <div>
            <p className="text-gray-500 uppercase text-xs font-medium">EXPIRY</p>
            <p className="font-semibold">
              {distributors.find((d) => d.id === selectedDistributor)?.exp || "-"}
            </p>
          </div>
          <div>
            <p className="text-gray-500 uppercase text-xs font-medium">LOCATION</p>
            <p className="font-semibold">-</p>
          </div>
          <div>
            <p className="text-gray-500 uppercase text-xs font-medium">MRP</p>
            <p className="font-semibold">
              {formatPrice(
                distributors.find((d) => d.id === selectedDistributor)?.price
              ) || "-"}
            </p>
          </div>
          <div>
            <p className="text-gray-500 uppercase text-xs font-medium">SALE RATE</p>
            <p className="font-semibold">-</p>
          </div>
          <div>
            <p className="text-gray-500 uppercase text-xs font-medium">STOCK</p>
            <p className="font-semibold text-green-600">
              {distributors.find((d) => d.id === selectedDistributor)?.stockQty || "-"}
            </p>
          </div>
        </div>
      </div>
    </div>

    {/* Right Section — Settings */}
    <div className="panel-actions">
      <button
        className="gradient-button"
        onClick={handleSettings}
      >
        Settings
      </button>

      {/* Settings Modal */}
      <Modal
        show={showSettingsModal}
        onHide={handleCloseSettings}
        centered
        size="md"
      >
        <Modal.Header closeButton style={{ borderBottom: "none" }}>
          <Modal.Title
            style={{
              borderBottom: "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              fontWeight: "600",
              fontSize: "22px",
            }}
          >
            <div>
              Update Settings
              <p style={{ color: "#959595ff", fontSize: "14px" }}>
                Fill in the details below to update
              </p>
            </div>
            <button className="gradient-button">Apply</button>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <AddSettings style={{ borderShadow: "none" }} />
        </Modal.Body>
      </Modal>
    </div>
  </div>
</div>


                <div className="tabs-container">
              <div className="tabs-header">
                {[
                  "Batches",
                  "Purchases",
                  "Sales",
                  "Distributor",
                ].map((t) => (
                  <button
                    key={t}
                    className={`tab-button ${t.toLowerCase() === activeTab ? "active" : ""}`}
                    onClick={() => setActiveTab(t.toLowerCase())}
                  >
                    {t}
                  </button>
                ))}
              </div>

              <div className="tab-content">
                {activeTab === "batches" && <PharmacyTable />}
                {activeTab === "purchases" && <PurchaseTable />}
                {activeTab === "sales" && <SalesTable />}
                {activeTab === "distributor" && <DistributorTable />}
              </div>
            </div>

            </>
          ) : (
            <div style={{ padding: 40 }}>
              <h3>Select a Distributor</h3>
              <p>Please select a distributor from the left panel to view details.</p>
            </div>
          )}
        </div>
      </div>


      
    </>
  );
}

export default PharmacyStock;
